import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { EqValidator, TextInputComponent } from '@equine-ui-nx/ui';
import { CustomValidator } from '../signup-form/custom.validator';

@Component({
  selector: 'signup-verify-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TextInputComponent],
  templateUrl: './signup-verify-form.component.html',
  styleUrl: './signup-verify-form.component.scss',
})
export class SignupVerifyFormComponent implements OnChanges, OnInit{
  
  @Input('isVerified') isVerified: boolean = false;
  @Input('errorCode') errorCode: string = '';
  @Output('resendOtp') resendOtp = new EventEmitter<void>();
  @Output('verify') verifyEvent = new EventEmitter<string>();
  @Input('appName') appName!: string;
  resendDisabled: boolean = false;
  logoUrl = ``
  backgroundImageId = ``
  signUpVerifyForm = new FormGroup({});
  otpValidators: EqValidator[] = [
    {
      validators: Validators.required,
      error: 'required',
      message: 'This field is required'
    },
    {
      validators: Validators.minLength(6),
      message: 'Should be 6 digit',
      error: 'minlength',
    },
    {
      validators: Validators.maxLength(6),
      message: 'Should be 6 digit',
      error: 'maxlength',
    },
    {
      validators: CustomValidator.customValidate(),
      message: 'Invalid Verification Code! Please enter again',
      error: 'InvalidVerificaitonCode',
    },
    {
      validators: CustomValidator.customValidate(),
      message: 'Reached Max attempt!',
      error: 'ReachedMaxAttempt',
    },
    {
      validators: CustomValidator.customValidate(),
      message: 'Verification code has exipred!',
      error: 'ExpiredVerificationCode',
    }
  ];
  ngOnInit(): void {
    if(this.appName == "arenaEqApp"){
      this.backgroundImageId = 'intro-arena'
      this.logoUrl = `assets/images/arenaEq-logo.png`
    }else{
      this.logoUrl = `../../../assets/images/access-logo-full.png`
      this.backgroundImageId = 'intro-iea'
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes['errorCode']?.currentValue) {
      if(changes['errorCode']?.currentValue == 'InvalidVerificaitonCode') {
        this.signUpVerifyForm.get('otp')?.setErrors({InvalidVerificaitonCode: true});
      } else if(changes['errorCode']?.currentValue == 'ReachedMaxAttempt') {
        this.signUpVerifyForm.get('otp')?.setErrors({ReachedMaxAttempt: true});
      } else if(changes['errorCode']?.currentValue == 'ExpiredVerificationCode') {
        this.signUpVerifyForm.get('otp')?.setErrors({ExpiredVerificationCode: true});
      } else {
        this.signUpVerifyForm.get('otp')?.setErrors(null);
      }
    } else {
      this.signUpVerifyForm.get('otp')?.setErrors(null);
    }
  }

  resend() {
    this.resendOtp.emit();
  }

  verify() {
    if(
      !this.signUpVerifyForm.get('otp')?.errors?.['required'] &&
      !this.signUpVerifyForm.get('otp')?.errors?.['minlength'] &&
      !this.signUpVerifyForm.get('otp')?.errors?.['maxlength']
    ) {
      this.verifyEvent.emit(this.signUpVerifyForm.get('otp')?.value);
    }
  }
}